export default "__VITE_ASSET__BbL$3TrP__"